<div class="account">
  <div class="container mt-2">
  <crm-alert #alert></crm-alert>
  <loader [loading]="isLoading"></loader>

    <div *ngIf="user" class="row">
      
      <div class="avatar col-12"  *ngIf="!isLoading">
        <div (click)="onChangeProfilePhoto()">
        <custom-avatar
        [id]="user?.ID"
          [name]="user?.getName()"
          [color]="user?.AVATAR_COLOR"
          [url]="user?.AVATAR_URL"
          size="120" ></custom-avatar>
          <p class="text_edit">Edit</p>
        </div>
          <button *ngIf="user?.AVATAR_URL" (click)="onDeleteProfilePhoto()" class="del_btn"><i class="fa fa-trash" ></i></button>
      </div>

      <div class="col-12" id="signature">
        <form name="form" #f="ngForm" novalidate>
          <div class="form-group">
            <label class="rbv-label" for="email">Email</label>
            <input type="email" id="email" class="form-control rounded-0 rbv-field" name="EMAIL"
              [(ngModel)]="user.EMAIL" [disabled]="true" placeholder="Enter your email" />
          </div>

          <div class="form-row">
            <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <label class="rbv-label" for="firstname">First Name</label>
              <input type="text" id="firstname" class="form-control rounded-0 rbv-field" name="FIRST_NAME"
                [(ngModel)]="user.FIRST_NAME" #FIRST_NAME="ngModel" placeholder="Enter your First Name" required />
              <div *ngIf="f.submitted && FIRST_NAME.invalid" class="invalid-feedback">
                <div *ngIf="FIRST_NAME.errors.required">First Name is required</div>
              </div>
            </div>

            <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <label class="rbv-label" for="lastname">Last Name</label>
              <input type="text" id="lastname" class="form-control rounded-0 rbv-field" name="LAST_NAME"
                [(ngModel)]="user.LAST_NAME" #LAST_NAME="ngModel" placeholder="Enter your Last Name" required />
              <div *ngIf="f.submitted && LAST_NAME.invalid" class="invalid-feedback">
                <div *ngIf="LAST_NAME.errors.required">Last Name is required</div>
              </div>
            </div>
          </div>

          <div class="from-group">
            <label class="rbv-label" for="signature">Signature</label>
            <!-- <angular-editor name="SIGNATURE" [(ngModel)]="user.SIGNATURE" [config]="editorConfig"></angular-editor> -->
            <quill-editor name="SIGNATURE" [(ngModel)]="user.SIGNATURE" [modules]="quillModules"></quill-editor>

            <button class="btn btn-rbv mt-2" (click)="onSetTemplate()">Reset Signature</button>
          </div>

          <div class="from-group mt-3 mb-4">
            <label class="rbv-label">Report Name Preference</label>

            <div class="d-flex">
              <div class="mr-3">
                <input class="checkbox-custom" type='radio' name="selectedDelay" id="corporate"
                  [ngModel]="user.NAME_PREF" [value]="'CORPORATE'" [checked]="user.NAME_PREF == 'CORPORATE'"
                  (ngModelChange)="setPreference($event)" />
                <label class="checkbox-custom-label" for="corporate">
                  Corporate Name</label>
              </div>

              <div class="mr-3">
                <input class="checkbox-custom" type='radio' name="selectedDelay" id="business"
                  [ngModel]="user.NAME_PREF" [value]="'BUSINESS'" [checked]="user.NAME_PREF == 'BUSINESS'"
                  (ngModelChange)="setPreference($event)" />
                <label class="checkbox-custom-label" for="business">
                  Doing Business As</label>
              </div>

              <div>
                <input class="checkbox-custom" type='radio' name="selectedDelay" id="internal"
                  [ngModel]="user.NAME_PREF" [value]="'INTERNAL'" [checked]="user.NAME_PREF == 'INTERNAL'"
                  (ngModelChange)="setPreference($event)" />
                <label class="checkbox-custom-label" for="internal">
                  Internal Name</label>
              </div>
            </div>
          </div>

          <div class="from-group mt-3 mb-4">
            <label class="rbv-label">Avatar Color</label>
            <div class="relative">
              <input class="color-picker-input" [style.background]="user.AVATAR_COLOR"
                [(colorPicker)]="user.AVATAR_COLOR" />
            </div>
          </div>

          <div class="from-group mt-3 mb-4">
            <label class="rbv-label">Theme Setting</label>
            <div class="d-flex mt-3">
              <span class="night-mode">Night Mode</span>
              <material-slide-toggle [name]="name" [id]="'materialSlideToggle'" [checked]="user.THEME_NIGHT"
                [disabled]="false" [aria-label]="'On/Off'" [aria-labelledby]="'Night Mode'"
                (change)="onToggleChange($event)">
              </material-slide-toggle>
            </div>
          </div>


          <div class="from-group mt-3 mb-4">
            <label class="rbv-label">Two Factor Authentication: <span class="tfa-label"
                [ngClass]="{'enabled': user.TFA, 'disabled': !user.TFA}">{{user.TFA ? 'Enabled' :
                'Disabled'}}</span></label>
            <div>
              <div class="night-mode">A second step after entering your password verifies it's you signing in</div>
              <button class="btn btn-rbv mt-3" (click)="setUpTfa()">{{ user.TFA ? 'Disable' : 'Enable'}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>